import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import PackagesProvider from "./context/PackagesContext";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "./context/ThemeContext"; // ✅ Import ThemeProvider

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ThemeProvider>
          <PackagesProvider>
            <AppRoutes />
            <Toaster position="top-right" reverseOrder={false} />
          </PackagesProvider>
        </ThemeProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;